/*=============================================== ModalPage ===============================================*/

import { useContext } from "react"
import { Flexbox, Button, Modal, Image } from "tsx-library-julseb"

import { ModalContext } from "context"
import type { ModalContextType } from "context"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, iconBoxicon } from "data"

const ModalPage = () => {
    const { isModalOpen, setIsModalOpen } = useContext(
        ModalContext
    ) as ModalContextType

    const items: ItemType[] = [
        {
            title: "",
            intro: "",
            content: (
                <Flexbox>
                    <Button onClick={() => setIsModalOpen(true)}>
                        Open modal
                    </Button>

                    <Modal
                        isOpen={isModalOpen}
                        setIsOpen={setIsModalOpen}
                        showCloseButton
                    >
                        <Image
                            src="/images/image-card.jpg"
                            alt="Demo img modal"
                            width="90%"
                            height="90%"
                            fit="contain"
                        />
                    </Modal>
                </Flexbox>
            ),
            code: "const [isOpen, setIsOpen] = useState(false)\n\n<Modal isOpen={isOpen} setIsOpen={setIsOpen} showCloseButton>\n\n</Modal>",
            codeTs: "const [isOpen, setIsOpen] = useState<boolean>(false)\n\n<Modal isOpen={isOpen} setIsOpen={setIsOpen} showCloseButton>\n\n</Modal>",
        },
    ]

    const introIconCommon: JSX.Element = (
        <>
            Only if <code>showCloseButton</code> is set to <code>true</code>.
        </>
    )

    const propsItems: PropsItemType[] = [
        {
            subtitle: "isOpen",
            type: "boolean",
            required: true,
        },
        {
            subtitle: "setIsOpen",
            type: "function",
            required: true,
        },
        {
            subtitle: "disableEsc",
            intro: (
                <>
                    Disable closing by typing on <code>esc</code> button.
                </>
            ),
            type: "boolean",
        },
        {
            subtitle: "showCloseButton",
            type: "boolean",
        },
        {
            subtitle: "iconClose",
            intro: (
                <>
                    {introIconCommon} {commonProps.addIconCapital}
                </>
            ),
            type: "string",
            default: iconBoxicon("x"),
        },
        {
            subtitle: "iconCloseSize",
            intro: introIconCommon,
            type: "number",
            default: "48 * 0.7",
        },
        {
            subtitle: "labelClose",
            intro: introIconCommon,
            type: "string",
            default: "Close",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ModalPage
